import React from 'react';
import {Button, Grid, Typography} from '@material-ui/core';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const LoginTroubleshooting = () => {
    const {t: translate} = useTranslation();

    return (
        <div className="rct-session-wrapper" style={{display: 'flex'}}>
            <div className="session-inner-wrapper" style={{alignSelf: 'center', width: '100%', transform: 'translate3d(0%, -10%, 0)'}}>
                <div className="container">
                    <div className="row row-eq-height" style={{flexDirection: 'column'}}>
                        <div className="col-sm-7 col-md-7 col-lg-8">
                            <div className="session-body text-center">
                                <Grid container spacing={4}>
                                    <Grid item xs={12}>
                                        <Typography variant='h4'>{translate('common.troubleshooting_title')}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Button
                                            color='primary'
                                            variant='contained'
                                            component={Link}
                                            to='/sendVerificationLetter'
                                        >
                                            {translate('users.email.actions.re_send_verification_letter')}
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Button
                                            color='primary'
                                            variant='contained'
                                            component={Link}
                                            to='/forgotPassword'
                                        >
                                            {translate('users.actions.forgot_password')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginTroubleshooting;